// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyCBqr4A8VbPqlZ6BFTC5-loj6VMt0uh-7s",
  authDomain: "tetris-60156.firebaseapp.com",
  projectId: "tetris-60156",
  storageBucket: "tetris-60156.appspot.com",
  messagingSenderId: "216269074665",
  appId: "1:216269074665:web:09cf06c3915dc833188078",
};
// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
